import { useEffect, useRef } from "react";

export const useCheckSize = (callback?: (isMore: boolean) => void) => {
  const $root = useRef<HTMLDivElement>(null);
  const $child = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkSize = () => {
      if ($child.current && $root.current) {
        const isMore = $child.current.clientWidth > $root.current.clientWidth;

        if (callback) {
          callback(isMore);
        }
      }
    };

    checkSize();

    window.addEventListener("resize", checkSize);

    return () => {
      window.removeEventListener("resize", checkSize);
    };
  }, []);

  return {
    $root,
    $child,
  };
};
